module.exports = __webpack_public_path__ + "static/media/star-of-life.4883b790.svg";